import React, { useEffect, useLayoutEffect, useState } from "react";
import { useStore } from "react-redux";
import { useMedia } from "use-media";
import { useHistory } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import common from "../../resources_catalog/js/common/common";
import right_arrow from "../../resources_catalog/icons/ico_right_arrow.svg";
import japan_img from "../../resources_catalog/images/japan_img.svg";
import world_img from "../../resources_catalog/images/world_img.svg";
import ico_right_arrow_gold from "../../resources_catalog/icons/ico_right_arrow_gold.svg";
import ico_right_arrow_gray from "../../resources_catalog/icons/ico_right_arrow_gray.svg";
import anchor_blank from "../../resources_catalog/icons/anchor_blank.svg";
import { getNewsList, getNewsListTest, getTopicsList, getTopicsListTest, getHotelList } from '../../const/index.js';
import hotel_img_jp_11 from "../../resources_catalog/images/hotel_japan/hotel_kv_jp_11.jpg";
import Const from "../../const/RTCC/Const";
import CommonUtil from "../../common/commonUtil";
import { useRtoaster } from "../../hooks/useRtoaster";

export const CatalogHomeContainer = (props) => {
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const isWideTablet = useMedia({ maxWidth: "960px" });
  //画面遷移に使います
  const history = useHistory();
  const store = useStore();
  // レスポンス設定リスト
  const [newsList, setNewsList] = useState([]);
  const [topicList, setTopicList] = useState([]);
  const [domesticHotelListTop, setDomesticHotelListTop] = useState([]);
  const [domesticHotelListBottom, setDomesticHotelListBottom] = useState([]);
  const [abroadHotelListTop, setAbroadHotelListTop] = useState([]);
  const [abroadHotelListBottom, setAbroadHotelListBottom] = useState([]);

  // rtoasterタグ生成
  useRtoaster();

  //この関数は画面レンダリング前に動きます
  useLayoutEffect(() => {
  })

  //この関数は画面レンダリング後に動きます
  useEffect(() => {
    if (CommonUtil.getDomain() == Const.RELEASE_PATH) {
      // お知らせApiリクエスト
      common.doGet(getNewsList, {}, afterGetNewsList);
      // トピックスリクエスト
      common.doGet(getTopicsList, {}, afterGetTopicList);
    } else {
      // お知らせApiリクエスト
      common.doGet(getNewsListTest, {}, afterGetNewsList);
      // トピックスリクエスト
      common.doGet(getTopicsListTest, {}, afterGetTopicList);
    }
    //  ホテル取得リクエスト
    common.doPost(getHotelList, {}, afterGetHotelList);
  }, []);

  // お知らせ一覧取得後処理
  const afterGetNewsList = (res) => {
    if (res.data) {
      let dataList = [];
      res.data.map((value) => {
        let data = {
          title: value.title,
          news_id: value.news_id,
          thumbnail_url: value.thumbnail_url,
          link_url: value.link_url,
          date: value.date
        };
        dataList.push(data);
      });
      setNewsList(dataList);
    }
  };

  // トピック一覧取得後処理
  const afterGetTopicList = (res) => {
    if (res.data) {
      let dataList = [];
      res.data.map((value) => {
        let data = {
          title: value.title,
          topics_id: value.topics_id,
          thumbnail_url: value.thumbnail_url,
          pdf_url: value.pdf_url,
          lead: value.lead,
          date: value.date
        };
        dataList.push(data);
      });
      setTopicList(dataList);
    }
  };

  // ホテル一覧取得後処理
  const afterGetHotelList = (res) => {
    if (res.data) {
      let domesticHotelListInfo = res.data.domesticHotelListInfo;
      let abroadHotelListInfo = res.data.abroadHotelListInfo;
      let domesticDataListTop = [];
      let domesticDataListBottom = [];
      let abroadDataListTop = [];
      let abroadDataListBottom = [];
      //　国内取得
      if (domesticHotelListInfo.length >= 8) {
        const half = Math.ceil(domesticHotelListInfo.length / 2);
        domesticHotelListInfo.map((value, index) => {
          let data = {
            propertyImages: value.propertyImages,
            cityName: value.cityName,
            hotelName: value.hotelName
          };
          if (index < half) {
            domesticDataListTop.push(data);
          } else {
            domesticDataListBottom.push(data);
          }
        });
        setDomesticHotelListTop(domesticDataListTop);
        setDomesticHotelListBottom(domesticDataListBottom);
      } else {
        domesticHotelListInfo.map((value) => {
          let data = {
            propertyImages: value.propertyImages,
            cityName: value.cityName,
            hotelName: value.hotelName
          };
          domesticDataListTop.push(data);
        });
        setDomesticHotelListTop(domesticDataListTop);
      }

      //　海外取得
      if (abroadHotelListInfo.length >= 8) {
        const half = Math.ceil(abroadHotelListInfo.length / 2);
        abroadHotelListInfo.map((value, index) => {
          let data = {
            propertyImages: value.propertyImages,
            cityName: value.cityName,
            hotelName: value.hotelName
          };
          if (index < half) {
            abroadDataListTop.push(data);
          } else {
            abroadDataListBottom.push(data);
          }
        });
        setAbroadHotelListTop(abroadDataListTop);
        setAbroadHotelListBottom(abroadDataListBottom);
      } else {
        abroadHotelListInfo.map((value) => {
          let data = {
            propertyImages: value.propertyImages,
            cityName: value.cityName,
            hotelName: value.hotelName
          };
          abroadDataListTop.push(data);
        });
        setAbroadHotelListTop(abroadDataListTop);
      }
    }
  };


  const domestic = () => {
    history.push("hotelLineupJp");
  }

  const abroad = () => {
    history.push("hotelLineupOverseas");
  }

  const newsDetail = (news_id) => {
    store.dispatch({ type: "NEWS", payload: { news: news_id } })
    history.push("newsDetail");
  }

  const newsAll = () => {
    history.push("newsAll");
  }

  const settings = {
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "20%",
    variableWidth: true,
  };

  const settingsTopics = {
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "20%",
    variableWidth: true,
  };

  // const settings = {
  //   infinite: true,
  //   arrows: true,
  //   speed: 500,
  //   slidesToScroll: 1,
  //   centerMode: true,
  //   centerPadding: "5%",
  //   variableWidth: true,
  // };

  // const settingsTopics = {
  //   infinite: true,
  //   arrows: true,
  //   speed: 500,
  //   slidesToScroll: 1,
  //   centerMode: true,
  //   centerPadding: "5%",
  //   variableWidth: true,
  // };

  // // 仮配列置き場
  // const newsListBlock = [
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: { world_img }, link_url: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: { world_img }, link_url: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: { world_img }, link_url: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: { world_img }, link_url: "", date: "2022.02.14" },
  //   { title: "北海道", news_id: "Aホテル", thumbnail_url: { world_img }, link_url: "", date: "2022.02.14" }
  // ];
  // const hotelLineUpOverseas = [
  //   { hotelTitle: "ハワイ", hotelName: "Aホテル", },
  //   { hotelTitle: "ハワイ", hotelName: "Bホテル", },
  //   { hotelTitle: "ハワイ", hotelName: "Cホテル", },
  //   { hotelTitle: "スペイン", hotelName: "Dホテル", },
  //   { hotelTitle: "スペイン", hotelName: "Eホテル", },
  //   { hotelTitle: "ハワイ", hotelName: "Aホテル", },
  //   { hotelTitle: "ハワイ", hotelName: "Bホテル", },
  //   { hotelTitle: "ハワイ", hotelName: "Cホテル", },
  //   { hotelTitle: "スペイン", hotelName: "Dホテル", },
  //   { hotelTitle: "スペイン", hotelName: "Eホテル", },
  // ]

  // const hotelLineUpJp = [
  //   { hotelTitle: "北海道", hotelName: "Aホテル", propertyImages: { hotel_img_jp_11 } },
  //   { hotelTitle: "北海道", hotelName: "Bホテル", propertyImages: { hotel_img_jp_11 } },
  //   { hotelTitle: "北海道", hotelName: "Cホテル", propertyImages: { hotel_img_jp_11 } },
  //   { hotelTitle: "北海道", hotelName: "Dホテル", propertyImages: { hotel_img_jp_11 } },
  //   { hotelTitle: "北海道", hotelName: "Eホテル", propertyImages: { hotel_img_jp_11 } },
  //   { hotelTitle: "北海道", hotelName: "Aホテル", propertyImages: { hotel_img_jp_11 } },
  //   { hotelTitle: "北海道", hotelName: "Bホテル", propertyImages: { hotel_img_jp_11 } },
  //   { hotelTitle: "北海道", hotelName: "Cホテル", propertyImages: { hotel_img_jp_11 } },
  //   { hotelTitle: "北海道", hotelName: "Dホテル", propertyImages: { hotel_img_jp_11 } },
  //   { hotelTitle: "北海道", hotelName: "Eホテル", propertyImages: { hotel_img_jp_11 } },
  // ]

  // const topicsList = [
  //   { thumbnail_url: "", lead: "テキストが入りますテキストが入りますテキストが入ります文字数制限あります" },
  //   { thumbnail_url: "", lead: "テキストが入りますテキストが入りますテキストが入ります文字数制限あります" },
  //   { thumbnail_url: "", lead: "テキストが入りますテキストが入りますテキストが入ります文字数制限あります" },
  //   { thumbnail_url: "", lead: "テキストが入りますテキストが入りますテキストが入ります文字数制限あります" },
  //   { thumbnail_url: "", lead: "テキストが入りますテキストが入りますテキストが入ります文字数制限あります" },
  // ]

  return (
    <div className="catalogHomeWrap">
      <div className="catalogHome">
        <div className="homeMainViewWrap">
          <div className="homeMainView">
            <div className="homeMainViewTitle">
              <p className="homeMainViewTitleText">WORLD<br />RESORT</p>
              <p className="homeMainViewTitleCaption">すべての人に、本物の感動を</p>
            </div>
          </div>
        </div>
        <div className="homeMainMenu">
          <div className="homeMainMenuInner">
            <div className="hotelLineUpInnerBox">
              <div className="hotelLineUpInnerBlock">
                <div className="hotelLineUpInnerBlockTitleWrap">
                  <p className="hotelLineUpInnerBlockTitle">お知らせ</p>
                  <p className="hotelLineUpInnerBlockNum">NEWS</p>
                </div>
                <a href="" className="hotelLineUpInnerBlockAll" onClick={newsAll}>
                  <p>一覧を見る</p>
                  <img src={ico_right_arrow_gold} alt="" />
                </a>
              </div>
              <div className="hotelLineUpNewsBlock">
                {
                  newsList && newsList.length >= 3 ?
                    newsList.filter((data, index) => index < 3).map((data, index) => (
                      <div key={"news" + index} className="hotelLineUpInnerNewsBlockWrap">
                        <div className="hotelLineUpInnerNewsBlock">
                          {data.link_url ?
                            <a className="Link" href={data.link_url} target="_blank" rel="noopener noreferrer">
                              <div className="hotelLineUpBlockTime">{data.date}</div>
                              <div className="hotelLineUpBlockNews">{data.title}</div>
                              <img src={anchor_blank} alt="" className="anchor_blank" />
                            </a>
                            :
                            <a className="Link" onClick={() => newsDetail(data.news_id)}>
                              <div className="hotelLineUpBlockTime">{data.date}</div>
                              <div className="hotelLineUpBlockNews">{data.title}</div>
                              <img src={ico_right_arrow_gray} alt="" className="ico_right_arrow" />
                            </a>
                          }
                        </div>
                      </div>
                    ))
                    : newsList.map((data, index) => (
                      <div key={"news" + index} className="hotelLineUpInnerNewsBlockWrap">
                        <div className="hotelLineUpInnerNewsBlock">
                          {data.link_url ?
                            <a className="Link" href={data.link_url} target="_blank" rel="noopener noreferrer">
                              <div className="hotelLineUpBlockTime">{data.date}</div>
                              <div className="hotelLineUpBlockNews">{data.title}</div>
                              <img src={anchor_blank} alt="" className="anchor_blank" />
                            </a>
                            :
                            <a className="Link" onClick={() => newsDetail(data.news_id)}>
                              <div className="hotelLineUpBlockTime">{data.date}</div>
                              <div className="hotelLineUpBlockNews">{data.title}</div>
                              <img src={ico_right_arrow_gray} alt="" className="ico_right_arrow" />
                            </a>
                          }
                        </div>
                      </div>
                    ))
                }
                {/* {
                  (function () {
                    const list = [];
                    for (let i = 0; i < 3; i++) {
                      list.push(
                        <div className="hotelLineUpInnerNewsBlockWrap">
                          <div className="hotelLineUpInnerNewsBlock">
                            <a className="Link" href={newsListBlock[i].link_url}>
                              <div className="hotelLineUpBlockTime">{newsListBlock[i].date}</div>
                              <div className="hotelLineUpBlockNews">{newsListBlock[i].title}</div>
                              <img src={ico_right_arrow_gray} alt="" className="ico_right_arrow" />
                            </a>
                          </div>
                        </div>
                      );
                    }
                    return <div>{list}</div>;
                  }())
                } */}
              </div>
            </div>
          </div>
        </div>
        <div className="hotelLineUp">
          <div className="hotelLineUpCategory">
            <img src={japan_img} alt="" />
            <p className="hotelLineUpTitle">RTCC宿泊{isWidePhone ? <br/> : " "}ホテルラインナップ<br />（国内・海外手配旅行）</p>
            <p className="hotelLineUpEnglish">RTCC HOTEL LINE UP</p>
          </div>
          <div className="hotelBlock">
            <Slider {...settings}>
              {
                domesticHotelListTop.map((data, index) => (
                  <div key={"hotel" + index} className="hotelLineUpListWrap">
                    <img src={data.propertyImages} onError={e => e.target.parentElement.style.display = "none"} style={{ display: "none" }} />
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={data.propertyImages} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">{data.cityName}</p>
                      <p className="hotelLineUpHotelName">{data.hotelName}</p>
                    </div>
                  </div>
                ))
              }
              {/* {
                <div>
                  <div key={"hotel"} className="hotelLineUpListWrap">
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                  </div>
                </div>
              } */}
            </Slider>
            {domesticHotelListBottom.length != 0 ?
              <Slider {...settings}>
                {
                  domesticHotelListBottom.map((data, index) => (
                    <div key={"hotel" + index} className="hotelLineUpListWrap">
                      <img src={data.propertyImages} onError={e => e.target.parentElement.style.display = "none"} style={{ display: "none" }} />
                      <div className="hotelLineUpList">
                        <div className="hotelLineUpImgWrap">
                          <img src={data.propertyImages} alt="" className="hotelLineUpImg" />
                        </div>
                        <p className="hotelLineUpHotelTitle">{data.cityName}</p>
                        <p className="hotelLineUpHotelName">{data.hotelName}</p>
                      </div>
                    </div>
                  ))
                }
                {/* {
                <div>
                  <div key={"hotel"} className="hotelLineUpListWrap">
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={hotel_img_jp_11} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">ああああ</p>
                      <p className="hotelLineUpHotelName">あああああああ</p>
                    </div>
                  </div>
                </div>
              } */}
              </Slider>
              :
              null
            }
          </div>
          <div className="catalogContentsButton" onClick={domestic}>
            <p>RTCC宿泊 ホテルラインナップ</p>
            <img src={right_arrow} alt="" />
          </div>
        </div>
        <div className="hotelLineUp">
          <div className="hotelLineUpBg"></div>
          <div className="hotelLineUpCategory">
            <img src={world_img} alt="" />
            <p className="hotelLineUpTitle">RTCCハワイ{isWidePhone ? <br/> : " "}ホテルラインナップ<br />（海外募集型企画旅行）
</p>
            <p className="hotelLineUpEnglish">HAWAII HOTEL LINE UP</p>
          </div>
          <div className="hotelBlock">
            <Slider {...settings}>
              {
                abroadHotelListTop.map((data, index) => (
                  <div key={"hotel" + index} className="hotelLineUpListWrap">
                    <img src={data.propertyImages} onError={e => e.target.parentElement.style.display = "none"} style={{ display: "none" }} />
                    <div className="hotelLineUpList">
                      <div className="hotelLineUpImgWrap">
                        <img src={data.propertyImages} alt="" className="hotelLineUpImg" />
                      </div>
                      <p className="hotelLineUpHotelTitle">{data.cityName}</p>
                      <p className="hotelLineUpHotelName">{data.hotelName}</p>
                    </div>
                  </div>
                ))
              }
              {/* {
                hotelLineUpOverseas.map((data, index) => (
                  <div key={"hotel"} className="hotelLineUpListWrap">
                    <div className="hotelLineUpListBlock">
                      <div className={"hotelLineUpImgOverseas" + index}></div>
                      <p className="hotelLineUpHotelTitle">{data.hotelTitle}</p>
                      <p className="hotelLineUpHotelName">{data.hotelName}</p>
                    </div>
                  </div>
                ))
              } */}
            </Slider>
            {abroadHotelListBottom.length != 0 ?
              <Slider {...settings}>
                {
                  abroadHotelListBottom.map((data, index) => (
                    <div key={"hotel" + index} className="hotelLineUpListWrap">
                      <img src={data.propertyImages} onError={e => e.target.parentElement.style.display = "none"} style={{ display: "none" }} />
                      <div className="hotelLineUpList">
                        <div className="hotelLineUpImgWrap">
                          <img src={data.propertyImages} alt="" className="hotelLineUpImg" />
                        </div>
                        <p className="hotelLineUpHotelTitle">{data.cityName}</p>
                        <p className="hotelLineUpHotelName">{data.hotelName}</p>
                      </div>
                    </div>
                  ))
                }
                {/* {
                hotelLineUpOverseas.map((data, index) => (
                  <div key={"hotel"} className="hotelLineUpListWrap">
                    <div className="hotelLineUpListBlock">
                      <div className={"hotelLineUpImgOverseas" + index}></div>
                      <p className="hotelLineUpHotelTitle">{data.hotelTitle}</p>
                      <p className="hotelLineUpHotelName">{data.hotelName}</p>
                    </div>
                  </div>
                ))
              } */}
              </Slider>
              :
              null
            }
          </div>
          <div className="catalogContentsButton" onClick={abroad}>
            <p>RTCCハワイ ホテルラインナップ</p>
            <img src={right_arrow} alt="" />
          </div>
        </div>
        <div className="topics">
          <div className="topicsBg"></div>
          <div className="hotelLineUp">
            <div className="hotelLineUpCategory">
              <p className="hotelLineUpTitle">トピックス</p>
              <p className="hotelLineUpEnglish">TOPICS</p>
            </div>
          </div>
          <div className="topicBlock">
            <Slider {...settingsTopics}>
              {
                topicList.map((data, index) => (
                  <div key={"topic" + index}>
                    <div className="topicList">
                      <div className={"topicImgWrap"}>
                        <img src={data.thumbnail_url} alt="" className="topicImg" />
                      </div>
                      <div className="topicTextWrap">
                        <p className="topicTitle">{data.lead}</p>
                        <a className="topicLInk" href={data.pdf_url} target="_blank" rel="noopener noreferrer">
                          詳細を見る
                          <img src={ico_right_arrow_gold} alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              }
              {/* {
                topicsList.map((data, index) => (
                  <div key={"topic" + index}>
                    <div className="topicList">
                      <div className={"topicImgWrap"}>
                        <img src={hotel_img_jp_11} alt="" className="topicImg" />
                      </div>
                      <div className="topicTextWrap">
                        <p className="topicTitle">{data.lead}</p>
                        <a className="topicLInk" href={data.pdf_url}>
                          詳細を見る
                          <img src={ico_right_arrow_gold} alt="" />
                        </a>
                      </div>

                    </div>
                  </div>
                ))
              } */}
            </Slider>
          </div>

        </div>
      </div>
    </div>
  );
};
